import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const SlidePanel = ({ isOpen, onClose, children, width = 560 }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/30 z-40"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          {/* Panel */}
          <motion.div
            className="fixed right-[0.5%] top-[1%] bottom-[1%] bg-white shadow-lg rounded-2xl z-50 flex flex-col"
            style={{ width }}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 100, damping: 20 }}
          >
            <div className="relative h-full">
              {/* Close button */}
              <div
                onClick={onClose}
                className="absolute top-0 right-0 h-[40px] w-[40px] bg-red-500 flex items-center justify-center cursor-pointer rounded-tr-[10px] rounded-bl-[20px]"
              >
                <X color="#fff" />
              </div>

              {children}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default SlidePanel;